import {useEffect, useState} from 'react';
import {Button, Col, Input, InputNumber, Row, Select, Typography} from 'antd';
import {useHistory} from 'react-router-dom';
import {PlansService} from './PlansService';
import {LevelsService} from '../Level/LevelsService';
import {CurriculumsService} from '../Curriculums/CurriculumsService';

const plansService = new PlansService();
const levelsService = new LevelsService();
const curriculumsService = new CurriculumsService();

export const PlanCreate = () => {
  const history = useHistory();
  const {Title, Text} = Typography;

  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [planName, setPlanName] = useState<string>('');
  const [duration, setDuration] = useState<number | null>(null);
  const [selectedLevelId, setSelectedLevelId] = useState<string>();
  const [selectedCurriculumId, setSelectedCurriculumId] = useState<string>();

  const [levels, setLevels] = useState<Array<any> | []>([]);
  const [curriculums, setCurriculums] = useState<Array<any> | []>([]);

  useEffect(() => {
    console.log('🔍 [PLAN-CREATE] Fetching levels and curriculums');

    levelsService
      .getNewLevels()
      .then(lvls => {
        console.log('✅ [PLAN-CREATE] Levels fetched:', lvls);
        setLevels(lvls);
      })
      .catch(error => {
        setIsError(true);
        console.error('❌ [PLAN-CREATE] Error fetching levels:', error);
      });

    curriculumsService
      .getCurriculums()
      .then(currs => {
        console.log('✅ [PLAN-CREATE] Curriculums fetched:', currs);
        setCurriculums(currs);
      })
      .catch(error => {
        setIsError(true);
        console.error('❌ [PLAN-CREATE] Error fetching curriculums:', error);
      });
  }, []);

  const handleCreate = async () => {
    console.log('🔍 [PLAN-CREATE] Creating plan with data:', {
      planName,
      duration,
      selectedLevelId,
      selectedCurriculumId,
    });

    if (planName && duration && selectedLevelId && selectedCurriculumId) {
      setIsLoading(true);

      await plansService
        .newCreatePlan(
          planName,
          duration,
          selectedLevelId,
          selectedCurriculumId,
        )
        .then((response: any) => {
          console.log('✅ [PLAN-CREATE] Plan created successfully:', response);
          alert('Plan Created Successfully');
          history.push('/plans');
        })
        .catch(err => {
          console.error('❌ [PLAN-CREATE] Error creating plan:', err);
          alert('Error creating plan: ' + JSON.stringify(err));
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      alert('Please fill in all required fields');
    }
  };

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>Create Plan</Title>
      <>
        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Plan Name *
              </Text>
              <Input
                placeholder={'Enter Plan Name'}
                onChange={e => setPlanName(e.target.value)}
                value={planName}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Duration (Days) *
              </Text>
              <InputNumber
                placeholder={'Enter duration in days'}
                onChange={value => setDuration(value)}
                value={duration}
                style={{width: '100%'}}
                min={1}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Level *
              </Text>
              <Select
                value={selectedLevelId}
                showSearch
                style={{width: '100%'}}
                placeholder="Select a Level"
                optionFilterProp="children"
                onChange={levelId => setSelectedLevelId(levelId)}>
                {levels?.map(level => (
                  <Select.Option
                    key={level.id || level._id}
                    value={level.id || level._id}>
                    {level.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <div style={{margin: 20}}>
              <Text style={{display: 'block'}} strong={true}>
                Select Curriculum *
              </Text>
              <Select
                value={selectedCurriculumId}
                showSearch
                style={{width: '100%'}}
                placeholder="Select a Curriculum"
                optionFilterProp="children"
                onChange={curriculumId =>
                  setSelectedCurriculumId(curriculumId)
                }>
                {curriculums?.map(curriculum => (
                  <Select.Option
                    key={curriculum.id || curriculum._id}
                    value={curriculum.id || curriculum._id}>
                    {curriculum.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
      </>

      <Button
        type="primary"
        size="large"
        loading={isLoading}
        onClick={handleCreate}
        style={{margin: 20}}>
        Create Plan
      </Button>
    </div>
  );
};
